import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class Session implements OnInit{
  public idToken : string;
  public accessToken : string;
  public currentUser : any;
  public loggedIn : any = false;

  // Observable currentLang source
  private _currentUserSource = new BehaviorSubject<any>(0);
  // Observable navItem stream
  currentUser$ = this._currentUserSource.asObservable();

  constructor(){
  }

  ngOnInit(){}

  setIdToken(data:any) {
    this.idToken = data;
    this.loggedIn = true;
  }

  setAccessToken(data:any) {
    this.accessToken = data;
  }

  setCurrentUser(data:any) {
    this.currentUser = data;
    this._currentUserSource.next(data);
  }

  destroy(){
    this.idToken = '';
    this.accessToken = '';
    this.currentUser = {};
    this.loggedIn = false;

    delete this.idToken;
    delete this.accessToken;
    delete this.currentUser;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/session/session.service.ts